<template>
    <div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
            <el-form-item label="选择制作人：" prop="producer_uids" :required="true">
                <JtCascader
                    popper-class="cascader-list-height-360"
                    v-model="ruleForm.producer_uids"
                    :options="producer_options"
                    clearable
                    filterable
                    :props="{ multiple: true, emitPath:false }"
                    :filter-method="filterMethod"
                    style="width: 360px;"
                ></JtCascader>
            </el-form-item>
            <el-form-item label="设置完成时间：" :required="true">
                <el-radio-group v-model="ruleForm.set_date_type">
                    <el-radio :label=1>按照期望日期指派</el-radio>
                    <el-radio :label=2>指定日期指派</el-radio>
                </el-radio-group>
            </el-form-item>

            <el-form-item label="" prop="finish_time" v-if="ruleForm.set_date_type == 2">
                <el-date-picker type="date" placeholder="选择日期" v-model="ruleForm.finish_time"
                                value-format="yyyy-MM-dd" clearable size="mini" style="width: 200px;" :picker-options="pickerOptions"></el-date-picker>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import {JtCascader } from '@/components/Ele';
import {wordToPinyin} from '@/utils';
export default {
    name:'BatchAssignFormItem',
    props: [ 'producer_options','param' ],
    components:{
        JtCascader,
    },
    data() {
        let _this = this;
            const validateFinishTime = (rule, value, callback) => {
                if(_this.ruleForm.set_date_type=='1'){
                    callback();
                }else{
                    if (!_this.ruleForm.finish_time) {
                        callback(new Error('请选择日期'));
                    }else{
                        callback();
                    }
                }
            };
        return {
            ruleForm: {
                type: 1,
                set_date_type: 1,
                finish_time:'',
                producer_uids:[]
            },
            rules:{
                producer_uids:[{
                    required: true,
                    message: '必填项不可为空',
                    trigger: 'change'
                }],
                finish_time:[
                    { validator: validateFinishTime, trigger: 'blur' }
                ],
            },
             pickerOptions:{
                disabledDate(time) {
                    return time.getTime() < (Date.now()-(24 * 60 * 60 * 1000));
                },
            },
        }
    },
    methods: {
        filterMethod(node, keyword){
            let py = wordToPinyin(node.label);
            let allStr = py.join('');
            let capStr = py.map(item=>item[0]).join('');
            return allStr.includes(keyword)||capStr.includes(keyword)||node.text.includes(keyword);
        },
        async getFormData(){
            await this.$refs.ruleForm.validate();
            const data = { ...this.ruleForm };
            if (this.param) {
                Object.assign(data, this.param);
            }
            return data;
        }
    }
}
</script>

<style lang="scss" scoped>


</style>